import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getSupplierListService = (params = {}) => {
  return api.get(url.GET_ALL_SUPPLIERS, params);
};

export const addSupplierService = (requestParams = {}) => {
  return api.create(url.POST_SUPPLIER, requestParams);
};

export const deleteSupplierService = (id) => {
  return api.delete(url.DELETE_SUPPLIER(id));
};

export const editSupplierService = (queryParams) => {
  return api.create(url.EDIT_SUPPLIER, queryParams);
};

// export const getCategoryByIdService=(id)=>{
//   return api.get(url.GET_MEAL_CATEGORY(id));
// }
